import React from 'react';
import Hero from '../components/Hero';
import service1 from '../assets/images/service1-hero-pg.jpg';

const Service1 = () => {
  return (
    <div>
      <Hero mainText="القياسات البيئية" imageSrc={service1} />
      <section className="content-section py-5 mt-5">
        <div className="container my-4">
          <p className="mb-4 lh-lg fs-5">
            إجراء القياسات البيئية بكافة أنواعها يتم وفقاً لقانون البيئة رقم 4 لسنة 1994 والقانون رقم 9 لسنة
            2009، ولائحته التنفيذية رقم 710 لسنة 2012 وتعديلاته رقم 618 لسنة 2017، بالإضافة إلى قانون العمل رقم
            12 لسنة 2003.
          </p>
          <h4 className="my-5">تتضمن الخدمات التي نقدمها:</h4>
          <ul className="d-flex flex-column gap-4 lh-lg fs-5">
            <li>
              قياسات الهواء العام باستخدام المختبر المتنقل، حيث نقوم بقياس الملوثات مثل (SO2، NO2، O3، CO، TSP،
              PM2.5، PM10، والمعادن الثقيلة).
            </li>
            <li>
              رصد الظروف المناخية مثل سرعة الرياح، اتجاه الرياح، درجة الحرارة، الرطوبة، ونمط الرياح وفقاً للطرق
              القياسية العالمية.
            </li>
            <li>
              قياس تركيز الانبعاثات الغازية من مداخن المنشآت الصناعية، بما في ذلك (SO2، NOx، CO، درجة الحرارة، O2،
              CO2، HCl، HF) باستخدام الأساليب القياسية العالمية.
            </li>
            <li>
              قياس تركيز انبعاثات الأتربة من مداخن المنشآت الصناعية، بما في ذلك الأتربة والرطوبة والمعادن الثقيلة،
              وفقاً للمعايير العالمية (EPA).
            </li>
            <li>
              إجراء قياسات بيئة العمل الداخلية بالمصانع، بما في ذلك الأتربة العالقة، الأتربة المستنشقة، شدة الضوضاء
              المكافئة، الوطأة الحرارية، شدة الإضاءة، وتركيز الغازات والأبخرة.
            </li>
          </ul>
          <div className="my-5 fs-5">
            <p>كما نقوم بسحب وتحليل مياه الصرف الصناعي والصحي ومياه الشرب.</p>
            <p>
              استشارات بيئية تتضمن إجراء قياسات للضوضاء المستمرة والعشوائية من مصادر صناعية أو مرورية أو إنشائية،
              بالإضافة إلى إعداد السجل البيئي وسجل المواد والمخلفات الخطرة.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service1;
